export const sidebarMenu = {
    Account: "Account",
    Profile: "Profile",
    Games: "Games",
    Promotion: "Promotion",
}